// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-group-item[data-v-00bd3806]{margin-left:25px;background-color:#fff}.not_dragging[data-v-00bd3806]{display:none}.dragging[data-v-00bd3806]{display:block;background-color:#d3d3d3;height:5px}.group_container[data-v-00bd3806]{cursor:pointer}.overed[data-v-00bd3806]{color:#187cc6;font-weight:700}.dragzone.overed[data-v-00bd3806]{background-color:#187cc6}", ""]);
// Exports
module.exports = exports;
